/**
 * @module websocket.event.handlers.flights.flight-updated
 */
import { store } from '../../../../state/store'
import { setFlightItemUpdated } from '../../../../state/websocket.slice'

export default function handleFlightUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleFlightUpdated', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setFlightItemUpdated(data))
  }
} 